var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWasteWaterDrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 19.881013,0.60521061 c 1.895219,2.30788849 2.980386,3.68345109 2.980386,5.22713799 a 2.980386,2.8275457 0 1 1 -5.960772,0 c 0,-1.5436869 1.085166,-2.9192495 2.980386,-5.22713799 z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 31.267615,5.1139993 c 1.89522,2.3078883 2.980386,3.683451 2.980386,5.2271377 a 2.980386,2.8275457 0 1 1 -5.960772,0 c 0,-1.5436867 1.085166,-2.9192494 2.980386,-5.2271377 z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 8.8306599,5.1139993 c 1.8952191,2.3078883 2.9803851,3.683451 2.9803851,5.2271377 a 2.9803857,2.8275454 0 1 1 -5.9607708,0 c 0,-1.5436867 1.0851661,-2.9192494 2.9803857,-5.2271377 z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 5.7738541,19.771383 H 34.691238 l 3.622315,18.860492 H 2.1515392 Z M 8.7848078,21.108348 c 1.2074383,-0.519656 3.4389062,-0.382101 4.6463452,0.137556 L 11.276105,37.462259 C 9.8241218,37.981916 7.4550974,38.07362 6.0031145,37.569251 Z M 17.527273,20.948254 c 1.207437,-0.519658 3.958563,-0.458521 5.166001,0.06114 l 0.733635,16.430332 c -1.451985,0.519657 -5.257707,0.504373 -6.694406,-0.01528 z M 31.660756,21.144435 c -1.207439,-0.519658 -3.438907,-0.382101 -4.646346,0.137556 l 2.155049,16.216356 c 1.451983,0.519656 3.821007,0.61136 5.27299,0.106992 z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasteWaterDrain);
export default __webpack_public_path__ + "static/media/waste_water_drain.081962f0ef4172f5f238b3b198413b88.svg";
export { ForwardRef as ReactComponent };